<template>
  <section class="fill-width fill-height library-webzine-cards">
    <template v-if="resultData.contentList.length > 0">
      <v-carousel v-model="model" height="100%" hide-delimiter-background hide-delimiters :continuous="false" :show-arrows="false">
        <v-carousel-item v-for="(item, index) in resultData.contentList" :key="index">
          <v-sheet
              height="100%"
              :style="{'background-image':'url(' + $downUrl(item.imgAtchFileName) + ')'}"
              class="sheet"
          >
            <v-row
                class="fill-height mt-0"
                justify="center"
            >
              <div class="pt-6">
                <div class="black--text fs-18 fw-500 text-center mb-7 px-7">
                  {{ item.libDtlTitle }}
                </div>
                <div class="black--text fs-16 px-7" v-html="item.content"></div>
              </div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
        <div class="pagination">{{ model + 1 }} / {{ resultData.contentList.length }}</div>
      </v-carousel>
    </template>
    <template v-else>
      <slot name="no-data">
        <NoData />
      </slot>
    </template>
  </section>
</template>

<script>
export default {
  props: {
    resultData: {
      type: Object,
      default () {
        return {
          contentList: []
        }
      }
    }
  },
  data: () => ({
    model: 0
  })
}
</script>
